import { FC, PropsWithChildren, useCallback } from "react";

import { Icon } from "capitalrx-components-2.0/lib/general";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { CSSProperties, useContext } from "react";

import { useNavigateSearch } from "@/premium/hooks";
import { EnrollmentContext } from "@/state";
import "./PlanCard.scss";

import { Card } from "../../../themedComponents/Card";

export interface PlanCardProps {
  id: number;
}

export const PlanCard: FC<PropsWithChildren<PlanCardProps>> = (props) => {
  const { children, id } = props;
  const navigateSearch = useNavigateSearch();
  const [state] = useContext(EnrollmentContext);
  const titleStyle: CSSProperties = {
    fontFamily: ((state.experienceData?.theme as { font?: string } | undefined)?.font || "Source Sans 3"),
  };

  const navigateToPlan = useCallback(() => {
    navigateSearch("/plan", {
      enrollmentPlan: id,
    });
  }, [id, navigateSearch]);

  return (
    <Card fullHeight={true}>
      <div className="plan-card-container" onClick={() => navigateToPlan()}>
        <Shelf>
          <div className="plan-card-title" style={titleStyle}>{children}</div>
          <Shelf.Spacer />
          <Icon name="chevron-right" color="lightgrey" />
        </Shelf>
      </div>
    </Card>
  );
};
